import React from "react";

const WalletIcons = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M28.3333 5H11.6667C7.98333 5 5 7.98333 5 11.6667V28.3333C5 32.0167 7.98333 35 11.6667 35H31.6667C33.5167 35 35 33.5167 35 31.6667V15C35 14.1159 34.6488 13.2681 34.0237 12.643C33.3986 12.0179 32.5507 11.6667 31.6667 11.6667V8.33333C31.6667 7.44928 31.3155 6.60143 30.6904 5.97631C30.0652 5.35119 29.2174 5 28.3333 5ZM28.3333 8.33333V11.6667H11.6667C10.45 11.6667 9.31667 12 8.33333 12.5667V11.6667C8.33333 9.83333 9.83333 8.33333 11.6667 8.33333M25.8333 25.8333C24.45 25.8333 23.3333 24.7167 23.3333 23.3333C23.3333 21.95 24.45 20.8333 25.8333 20.8333C27.2167 20.8333 28.3333 21.95 28.3333 23.3333C28.3333 24.7167 27.2167 25.8333 25.8333 25.8333Z"
        fill="#14141E"
      />
    </svg>
  );
};

export default WalletIcons;
